import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import SectionTitle from "../../components/SectionTitle";
import makeRequest from "../../makeRequest";

function getYoutubeId(url) {
  const m = url.match(/[?&]v=([^&#]+)/) || url.match(/youtu\.be\/([^?#]+)/) || url.match(/embed\/([^?#]+)/) || url.match(/shorts\/([^?#]+)/);
  return m ? m[1] : null;
}

function VlogCard({ vlog }) {
  const vid = getYoutubeId(vlog.youtubeUrl || "");
  const thumb = vid ? `https://img.youtube.com/vi/${vid}/mqdefault.jpg` : null;
  const embedUrl = vid ? `https://www.youtube.com/embed/${vid}` : null;

  return (
    <div className="col-xl-4 col-lg-4 col-md-6 mb-30 wow animate__fadeInUp" data-wow-duration=".9s">
      <div
        style={{
          borderRadius: 12,
          overflow: "hidden",
          boxShadow: "0 2px 16px rgba(0,0,0,0.08)",
          background: "#fff",
          height: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {embedUrl ? (
          <div style={{ position: "relative", paddingBottom: "56.25%", height: 0 }}>
            <iframe
              src={embedUrl}
              title={vlog.title}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                border: 0,
              }}
            />
          </div>
        ) : thumb ? (
          <img src={thumb} alt={vlog.title} style={{ width: "100%", height: 200, objectFit: "cover" }} />
        ) : (
          <div
            style={{
              height: 200,
              background: "#f3f4f6",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#9ca3af",
            }}
          >
            <i className="fa-solid fa-video" style={{ fontSize: 36 }} />
          </div>
        )}
        <div style={{ padding: "16px 18px 18px" }}>
          <h6
            style={{
              fontSize: "1rem",
              fontWeight: 600,
              marginBottom: 6,
              color: "#111827",
              lineHeight: 1.4,
            }}
          >
            {vlog.title}
          </h6>
          {vlog.description && (
            <p
              style={{
                fontSize: "0.85rem",
                color: "#6b7280",
                margin: 0,
                display: "-webkit-box",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
              }}
            >
              {vlog.description}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}

const VlogArea = () => {
  const [vlogs, setVlogs] = useState([]);

  useEffect(() => {
    makeRequest({
      route: "/website/vlog/public?perPage=6&page=1",
      method: "get",
    })
      .then((data) => setVlogs(data?.data || []))
      .catch(() => {});
  }, []);

  if (vlogs.length === 0) return null;

  return (
    <div className="it-blog-area fix p-relative pt-75 pb-60" style={{ background: "#f8fafc" }}>
      <div className="container">
        <div className="it-blog-title-box mb-50">
          <div className="row align-items-end">
            <div className="col-xl-7 col-lg-6 col-md-6">
              <div>
                <span className="mh-lf-section__eyebrow">
                  <svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path d="M10 2a1 1 0 011 1v5h5a1 1 0 010 2h-5v5a1 1 0 01-2 0v-5H4a1 1 0 010-2h5V3a1 1 0 011-1z" />
                  </svg>
                  Insights From Experts
                </span>
                <h2 className="mh-lf-section__title" style={{ marginBottom: 0 }}>
                  Our Latest Vlogs
                </h2>
              </div>
            </div>
            <div className="col-xl-5 col-lg-6 col-md-6" style={{ textAlign: "right" }}>
              <Link
                to="/vlogs"
                className="it-btn"
                style={{
                  display: "inline-block",
                  padding: "10px 28px",
                  borderRadius: 6,
                  background: "#076cec",
                  color: "#fff",
                  fontWeight: 600,
                  fontSize: "0.9rem",
                  textDecoration: "none",
                }}
              >
                See All Vlogs
              </Link>
            </div>
          </div>
        </div>
        <div className="row">
          {vlogs.map((v) => (
            <VlogCard key={v.id} vlog={v} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default VlogArea;
